import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './_services/authentication/authentication.service';
@Component({
    template: require('./log-in.template.html')
})
export class LogInComponent implements OnInit {
    constructor(private auth: AuthenticationService, private route: ActivatedRoute, private router: Router) {}

	username: string;
	password: string;

	isSigningIn: boolean;

    signIn() {
        this.isSigningIn = true;
        this.auth.logIn(this.username, this.password).then(() => {
            this.isSigningIn = false;
            this.doRedirect();
        }, error => {
            this.isSigningIn = false;
        });
    }
    ngOnInit() {
        if (this.auth.authenticatedUser) {
            this.doRedirect();
        }
    }

    private doRedirect() {
        console.log("Redirecting", this.route.snapshot.queryParams['returnUrl']);
        if (this.route.snapshot.queryParams['returnUrl']) {
            this.router.navigateByUrl(this.route.snapshot.queryParams['returnUrl']);
        } else {
            this.router.navigateByUrl('/dashboard');
        }
    }

  
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/log-in.component.ts